<div
  *ngIf="state && chargingStateIcon"
  class="flex items-center justify-center w-24 h-24 transition-all delay-75 bg-white border rounded-full cursor-pointer hover:scale-105"
  [ngClass]="getStartChargingClasses()"
  [class.disabled]="disabled"
  (click)="startChargingHandler()"
>
  <span class="w-8 h-8 fill-current" [inlineSVG]="chargingStateIcon"></span>
</div>
